export default __webpack_public_path__ + "static/media/rm10.84052cd1.png";